<template>
    <div class="detail-layout">
        <CampaignPicture class="layout-picture"
            :imgCls="'default'"
            :campaign="detailController.campaign"
            :campaignImage="detailController.campaign.pictures"
            :campaignQty="detailController.campaign.qty" />

        <DetailInfo class="layout-info"
            :lbl="lbl"
            :campaign="detailController.campaign" />

        <DetailAndCondition
            :lbl="lbl"
            :campaign="detailController.campaign" />

        <RedeemButton
            class="layout-redeem"
            :isLogin="isLogin"
            :userPoint="userPoint"
            :detailController="detailController"
            :redeemController="redeemController"
            :modalController="modalController"
            :lblRedeemBTN="lbl.redeem_button"
            :lblModal="lbl.modalSkip"
            :redeemType="type"
            @clickRedeem="clickRedeem()"
            @setUsePoint="setUsePoint($event)"
            />

    </div>
</template>
<script>
//mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import CampaignPicture from '../detail/Picture.vue';
import DetailInfo from '../detail/DetailInfo.vue';
import DetailAndCondition from '../detail/DetailAndCondition.vue';
import RedeemButton from '../detail/RedeemButton.vue';
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * Property
 * @property {boolean} inLogin
 * @property {object} lbl
 * @property {number} localeCode
 * @property {number} userPoint
 * @property {object} detailController
 * @property {object} modalController
 * @property {object} redeemController
 * Method
 * @method initialLayout Setup campaign information.
 * @method updateSelectedCampaignInfo Callback for subcampagin to update Campaign information.
 */
export default {
    name: 'DonateLayout',
    mixins: [ErrorApiMixin],
    components: {
        CampaignPicture,
        DetailInfo,
        DetailAndCondition,
        RedeemButton,
    },
    props: {
        isLogin: Boolean,
        lbl: Object,
        localeCode: Number,
        userPoint: Number,
        //controller
        detailController: Object,
        modalController: Object,
        redeemController: Object,
        type: String,
    },
    data: function (){
        return {
            usePoint: null,
        }
    },
    created: function () {
        this.initialDetailControllerEvent();
    },
    methods: {
        setUsePoint: function(points) {
            this.usePoint = points
        },
        clickRedeem: function () {
            var selectCampaignId = this.detailController.selectedCampaignId;
            var selectedQuantity = this.detailController.selectedQuantity;
            this.redeemController.setTotalPoint(this.usePoint)
            let tracking = new TrackingService(this)
            this.redeemController.clickRedeem(selectCampaignId, selectedQuantity, tracking);
        },
        //method
        initialDetailControllerEvent: function () {

        },
        initialRedeemControllerEvent: function () {
            this.redeemController.onRedeemSuccess(data => {
                console.log(data);
                this.detailController.reinitialCampaign(true);
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import './layout.scss';
</style>
